import { CdkDragEnter, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { AfterViewInit, ChangeDetectorRef, Directive, Renderer2, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

import { BoardsAbstract } from '@main-application/boards/abstract/board-abstract.component';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';

@Directive()
export class TemplateEditorBaseDnd extends BoardsAbstract implements AfterViewInit {
  target?: CdkDropList;
  targetIndex?: number;
  source?: CdkDropList;
  sourceIndex?: number;
  @ViewChild(CdkDropList) placeholder: CdkDropList;

  constructor(
    protected store: Store<{}>,
    protected snackbarService: SnackbarService,
    private renderer: Renderer2,
    protected cdr: ChangeDetectorRef
  ) {
    super(store, snackbarService);
  }

  trackById<T>(key: keyof T, _index: number, item: T) {
    return item?.[key];
  }

  ngAfterViewInit() {
    const phElement = this.placeholder.element.nativeElement;
    this.renderer.setStyle(phElement, 'display', 'none');
    this.renderer.removeChild(phElement.parentNode, phElement);
  }
  drop<T>(data: T[]) {
    if (!this.target) return;

    const phElement = this.placeholder.element.nativeElement;
    const parent = phElement.parentNode;

    this.renderer.setStyle(phElement, 'display', 'inline');

    this.renderer.removeChild(parent, phElement);

    this.renderer.insertBefore(parent, this.source.element.nativeElement, parent.children[this.sourceIndex]);

    if (this.sourceIndex != this.targetIndex) {
      moveItemInArray(data, this.sourceIndex, this.targetIndex);
    }

    this.target = undefined;
    this.source = undefined;
    this.targetIndex = undefined;
    this.sourceIndex = undefined;
    this.cdr.detectChanges();
  }

  enter(e: CdkDragEnter) {
    //console.log('enter', e);
    const drag = e.item;
    const drop = e.container;

    if (drop === this.placeholder) return;

    const phElement = this.placeholder.element.nativeElement;
    const dropElement = drop.element.nativeElement;

    const dragIndex =
      typeof this.sourceIndex === 'number'
        ? this.sourceIndex
        : __indexOf(dropElement.parentNode.children, drag.dropContainer.element.nativeElement);

    const dropIndex = __indexOf(dropElement.parentNode.children, dropElement);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;
      const sourceElement = this.source.element.nativeElement;

      this.renderer.removeChild(sourceElement.parentNode, sourceElement);
    }

    this.renderer.setStyle(phElement, 'display', '');
    //console.log({ dropIndex, sourceIndex: this.sourceIndex, targetIndex: this.targetIndex });

    if (this.sourceIndex < dropIndex) {
      if (dropIndex < this.targetIndex) {
        this.renderer.insertBefore(dropElement.parentElement, phElement, dropElement);
      } else {
        this.renderer.insertBefore(dropElement.parentElement, phElement, dropElement.nextSibling);
      }
    } else {
      if (this.targetIndex < dropIndex) {
        this.renderer.insertBefore(dropElement.parentElement, phElement, dropElement.nextSibling);
      } else {
        this.renderer.insertBefore(dropElement.parentElement, phElement, dropElement);
      }
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    this.placeholder._dropListRef.enter(
      drag._dragRef,
      drag.element.nativeElement.offsetLeft,
      drag.element.nativeElement.offsetTop
    );

    this.cdr.detectChanges();
  }
}

function __indexOf(collection: any, node: any) {
  return Array.prototype.indexOf.call(collection, node);
}
